import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const BackIconCD = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)

  if (!state.locationDesignConfig?.baseColors) return null

  return (
    <svg
      {...props}
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="23"
        cy="23"
        r="21.5"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="3"
      />
      <path
        d="M11.1714 23H34.8285"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M17.7427 15.7734L10.5142 23.002L17.7427 30.2306"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BackIconCD
